module.exports = __webpack_public_path__ + "img/r5.82dfe02f.svg";